import React from 'react';
import { ActionElement } from '../../elements/ActionElement';
import { transformFirstLetter, getRandomAmount, flatArrayBrowserCompatibly } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { allowedTimeSlotListProps } from './_allowedPropTypes';

const pseudoTimeSlots = flatArrayBrowserCompatibly(
  [4, 12, 7].map((numberOfTimeSlots, dateIndex) => new Array(numberOfTimeSlots).fill().map((_, hourIndex) => {
    const pseudoDate = new Date();
    pseudoDate.setDate(pseudoDate.getDate() + dateIndex);
    pseudoDate.setHours(hourIndex + 10, 0, 0, 0);

    return { startsAt: pseudoDate.toISOString() };
  }))
);

const { length: pseudoTimeSlotsLen } = pseudoTimeSlots;
new Array(Math.round(pseudoTimeSlotsLen * 0.35)).fill().forEach(() => {
  const randomPseudoProductIndex = Math.round(getRandomAmount(0, pseudoTimeSlotsLen - 1));
  pseudoTimeSlots[randomPseudoProductIndex].isBooked = true;
});

/* const getRowId = function (startDate, endDate) {
  return [startDate, endDate]
    .map(dateString => new Date(dateString).toISOString())
    .join(';');
}; */

const groupTimeSlotsByDate = function (listData) {
  const timeSlotsByDate = [];
  let currentData = {};
  let currentTimeSlots = [];

  const registerTimeslotData = function () {
    currentData.timeSlots = currentTimeSlots;
    timeSlotsByDate.push(currentData);
  };

  const ungroupedTimeSlots = listData || pseudoTimeSlots;

  ungroupedTimeSlots.forEach(timeSlot => {
    const { startsAt } = timeSlot;
    const { dateString: currentDateString } = currentData;

    if (currentDateString !== startsAt) {
      if (currentDateString) {
        registerTimeslotData();
      }

      currentData = { dateString: startsAt };
      currentTimeSlots = [];
    }

    currentTimeSlots.push({
      ...timeSlot,
      startsAt: new Date(startsAt)
    });
  });

  registerTimeslotData();
  return timeSlotsByDate;
};

const TimeSlotList = props => {
  const {
    listData,
    title,
    classNames: passedClassNames = [],
    formatDateTime,
    timeFormat,
    hour12,
    getNormalTimeSlotProps = () => ({
      type: 'pseudo',
      appearance: 'button',
      buttonColor: 'enhanced'
    }),
    getDisabledTimeSlotProps = () => ({
      appearance: 'buttonOutline',
      buttonColor: 'secondary'
    })
  } = props;

  const {
    renderTermContent = ({ dateString }) => (!listData ? <div className='placeholder-term' /> : (
      transformFirstLetter(
        formatDateTime(dateString, {
          weekday: 'short',
          month: 'long',
          day: 'numeric'
        }), 'upper')
    )),
    renderDefinitionContent = ({ startsAt, actionElementProps }) => {
      const finalActionElementProps = { ...actionElementProps };

      if (!listData) {
        finalActionElementProps.buttonColor = 'gray';
      }

      return (
        <ActionElement {...finalActionElementProps}>
          {listData ? formatDateTime(startsAt, { ...timeFormat, hour12 }) : null}
        </ActionElement>
      );
    }
  } = props;

  const groupedTimeSlots = groupTimeSlotsByDate(listData);
  const classNames = [...passedClassNames, 'timeSlot-list'];

  if (!listData) {
    classNames.push('no-data');
  }

  return (
    <dl className={classNames.join(' ')} title={title}>
      {groupedTimeSlots.map(({ dateString, timeSlots }) => (
        <div className='definition-wrapper'>
          <dt>{renderTermContent({ dateString, timeSlots, formatDateTime })}</dt>

          <div className='definition-description-area'>
            {timeSlots.map(timeSlotData => {
              const { startsAt, isBooked } = timeSlotData;
              let actionElementProps = {
                disabled: isBooked,
                letButtonShrink: true,
                ...getNormalTimeSlotProps(timeSlotData)
              };

              if (isBooked) {
                actionElementProps = {
                  ...actionElementProps,
                  ...getDisabledTimeSlotProps(timeSlotData)
                };
              }

              return (
                <dd>
                  {renderDefinitionContent({
                    startsAt,
                    actionElementProps,
                    timeSlotData,
                    formatDateTime
                  })}
                </dd>
              );
            })}
          </div>
        </div>
      ))}
    </dl>
  );
};

TimeSlotList.propTypes = allowedTimeSlotListProps;

export default withLocalization(TimeSlotList);